import { SessionType } from '@sondermind/utilities/models-session';

import { ProposalStatus } from './proposal-status.enum';

export class TimeProposal {
  id: number;
  locationName: string;
  startTime: Date | null;
  proposalStatus?: ProposalStatus;
  sessionType: SessionType;

  constructor(json: ITimeProposalApiResponse) {
    this.id = json.id;
    this.locationName = json.location_name;
    this.startTime = json.start_time ? new Date(json.start_time) : null;
    this.proposalStatus = json.proposal_status || ProposalStatus.PENDING;
    this.sessionType = json.session_type;
  }
}

export type ITimeProposalApiResponse = {
  /* eslint-disable @typescript-eslint/naming-convention */
  id: number;
  location_name: string;
  start_time: Date;
  proposal_status: ProposalStatus;
  session_type: SessionType;
  /* eslint-enable @typescript-eslint/naming-convention */
};
